import React from 'react';
import { useIntl } from 'react-intl';
import { Icon, Table } from 'semantic-ui-react';

const VocabularyRoleActionCell = ({
  content,
  code,
  field,
  hasError,
  iconTitle,
}) => {
  const intl = useIntl();
  const shouldFallback = !content;
  const fallback = intl.formatMessage({ id: `vocabulary.role-actions.${field}.table.placeholder` });
  const displayContent = shouldFallback ? fallback : content;

  const renderWrappedContent = () => {
    if (code && shouldFallback) {
      return (
        <code>
          <i>{displayContent}</i>
        </code>
      );
    }

    if (code) {
      return <code>{displayContent}</code>;
    }

    if (shouldFallback) {
      return <i>{displayContent}</i>;
    }

    return displayContent;
  };

  return (
    <Table.Cell className="td-vocabulary">
      {renderWrappedContent()}
      {hasError && <Icon className="ml-5" name="warning sign" title={iconTitle} />}
    </Table.Cell>
  );
};

export default VocabularyRoleActionCell;
